import React from 'react';
import { motion } from 'framer-motion';
import { KeyIcon } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
export function DeepFearsSection() {
  const fears = [{
    title: '1. Miedo a envejecer invisible',
    desc: 'No es solo perder conexión con tu pareja. Es sentir que dejaste de ser mujer para convertirte solo en función: mamá, administradora, cuidadora, soporte emocional.'
  }, {
    title: '2. Miedo a romper el hogar',
    desc: 'No aguantas porque no te importe. Aguantas porque sientes que una mala decisión podría afectar a tus hijos, tu estabilidad, tu economía y todo lo que construyeron.'
  }, {
    title: '3. Miedo a descubrir que ya no hay vuelta atrás',
    desc: 'Te duele pensar que quizá esperaste demasiado. Que el amor no explotó un día… sino que se fue apagando lentamente mientras todo seguía “normal”.'
  }];
  const erosionSigns = ['conversaciones que ya no conectan,', 'silencios que se vuelven normales,', 'necesidades emocionales no atendidas,', 'distancia disfrazada de costumbre,', 'una mujer sosteniendo cada vez más sola…'];
  return <section className="py-8 md:py-12 px-6 bg-[#FFF5F5]" data-id="element-98">
      <div className="max-w-4xl mx-auto" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-101">
            LO QUE MÁS TE DUELE NO SIEMPRE ES LO QUE DICES EN VOZ ALTA
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-10" data-id="element-102">
          {fears.map((fear, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-warmWhite p-6 md:p-8 rounded-2xl shadow-sm border border-softGold/30 hover:shadow-md transition-shadow" data-id="element-103">
              <h3 className="text-xl font-bold text-terracotta mb-4" data-id="element-104">
                {fear.title}
              </h3>
              <p className="text-mutedBrown leading-relaxed" data-id="element-105">{fear.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto" data-id="element-106">
          <h3 className="text-2xl md:text-3xl font-bold mb-6 text-center" data-id="element-107">
            NO ESTÁS EXAGERANDO. Y NO ESTÁS LOCA.
          </h3>

          <div className="space-y-4 text-lg text-mutedBrown leading-relaxed" data-id="element-108">
            <p data-id="element-109">Lo que vives tiene nombre.</p>
            <p data-id="element-110">
              No es solo una mala etapa. No es solo cansancio. No es solo
              rutina.
            </p>
            <p className="font-medium text-warmBrown" data-id="element-111">
              Es una erosión silenciosa del vínculo.
            </p>
            <p data-id="element-112">Una desconexión que se instala poco a poco:</p>

            <ul className="space-y-3 pl-6 border-l-2 border-softGold/50 italic" data-id="element-113">
              {erosionSigns.map((sign, index) => <li key={index} data-id="element-114">{sign}</li>)}
            </ul>

            <p className="pt-4 text-xl font-medium text-warmBrown text-center" data-id="element-115">
              …hasta que un día deja de sentirse esposa y empieza a sentirse
              espectadora.
            </p>

            <p className="pt-4" data-id="element-116">
              Cuando entiendes esto, dejas de culparte. Y por fin puedes ver con
              claridad qué está pasando de verdad.
            </p>
          </div>

          <div className="mt-8" data-id="element-117">
            <CTAButton text="QUIERO ENTENDER LA RAÍZ DEL PROBLEMA" icon={<KeyIcon className="w-5 h-5" data-id="element-119" />} data-id="element-118" />
          </div>
        </motion.div>
      </div>
    </section>;
}